<mat-card class="regulatory-title-card">
  <mat-card-header>
    <mat-card-title>{{ 'SMS_REGULATION.SOUTH_AFRICA.TITLE' | translate }}</mat-card-title>
    <mat-card-subtitle>{{ 'SMS_REGULATION.SOUTH_AFRICA.SUBTITLE' | translate }}</mat-card-subtitle>
  </mat-card-header>
</mat-card>

<form [formGroup]="formGroup">
  <div class="regulatory-form">
    <div class="regulatory-form-column">
      <mat-card>
        <mat-card-header>
          <mat-card-title>{{ 'SMS_REGULATION.SOUTH_AFRICA.BUSINESS_IDENTITY.TITLE' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content formGroupName="businessIdentity">
          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGULATION.SOUTH_AFRICA.BUSINESS_IDENTITY.BUSINESS_NAME' | translate }}</glxy-label>
            <input matInput formControlName="businessName" />
          </glxy-form-field>
          <glxy-form-field [required]="true">
            <glxy-label>{{
              'SMS_REGULATION.SOUTH_AFRICA.BUSINESS_IDENTITY.BUSINESS_REGISTRATION_NUMBER' | translate
            }}</glxy-label>
            <input matInput formControlName="businessRegistrationNumber" />
          </glxy-form-field>

          <sms-document-uploader
            [parentFormGroup]="businessIdentityFormGroup"
            [options]="[
              {
                label: 'SMS_REGULATION.SOUTH_AFRICA.BUSINESS_IDENTITY.ACCEPTED_DOCUMENTS.BUSINESS_REGISTRATION',
                value: 'business_registration',
              },
              {
                label: 'SMS_REGULATION.SOUTH_AFRICA.BUSINESS_IDENTITY.ACCEPTED_DOCUMENTS.CERTIFIED_LETTERHEAD',
                value: 'business_letterhead',
              },
            ]"
            [fieldTitle]="'SMS_REGULATION.SOUTH_AFRICA.BUSINESS_IDENTITY.ACCEPTED_DOCUMENTS.TITLE'"
            [fieldHint]="'SMS_REGULATION.SOUTH_AFRICA.BUSINESS_IDENTITY.ACCEPTED_DOCUMENTS.HINT'"
          ></sms-document-uploader>
        </mat-card-content>
      </mat-card>

      <mat-card>
        <mat-card-header>
          <mat-card-title>{{ 'SMS_REGULATION.SOUTH_AFRICA.BUSINESS_ADDRESS.TITLE' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <sms-address-fields [parentFormGroup]="businessAddressFormGroup"></sms-address-fields>

          <sms-document-uploader
            [parentFormGroup]="businessAddressFormGroup"
            [options]="[
              {
                label: 'SMS_REGULATION.SOUTH_AFRICA.BUSINESS_ADDRESS.ACCEPTED_DOCUMENTS.BANK_STATEMENT',
                value: 'bank_statement',
              },
              {
                label: 'SMS_REGULATION.SOUTH_AFRICA.BUSINESS_ADDRESS.ACCEPTED_DOCUMENTS.MUNICIPAL_RATES_OR_TAX_INVOICE',
                value: 'tax_document',
              },
              {
                label: 'SMS_REGULATION.SOUTH_AFRICA.BUSINESS_ADDRESS.ACCEPTED_DOCUMENTS.RECENT_PHONE_BILL',
                value: 'phone_bill',
              },
              {
                label: 'SMS_REGULATION.SOUTH_AFRICA.BUSINESS_ADDRESS.ACCEPTED_DOCUMENTS.NEW_VEHICLE_LICENSE',
                value: 'drivers_license',
              },
            ]"
            [fieldTitle]="'SMS_REGULATION.SOUTH_AFRICA.BUSINESS_ADDRESS.ACCEPTED_DOCUMENTS.TITLE'"
            [fieldHint]="'SMS_REGULATION.SOUTH_AFRICA.BUSINESS_ADDRESS.ACCEPTED_DOCUMENTS.HINT'"
          ></sms-document-uploader>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="regulatory-form-column">
      <mat-card>
        <mat-card-header>
          <mat-card-title>{{
            'SMS_REGULATION.SOUTH_AFRICA.AUTHORIZED_REPRESENTATIVE.TITLE' | translate
          }}</mat-card-title>
        </mat-card-header>
        <mat-card-content formGroupName="contact">
          <glxy-form-row>
            <glxy-form-field [required]="true">
              <glxy-label>{{
                'SMS_REGULATION.SOUTH_AFRICA.AUTHORIZED_REPRESENTATIVE.FIRST_NAME' | translate
              }}</glxy-label>
              <input matInput formControlName="contactFirstName" />
            </glxy-form-field>
            <glxy-form-field [required]="true">
              <glxy-label>{{
                'SMS_REGULATION.SOUTH_AFRICA.AUTHORIZED_REPRESENTATIVE.LAST_NAME' | translate
              }}</glxy-label>
              <input matInput formControlName="contactLastName" />
            </glxy-form-field>
          </glxy-form-row>
          <glxy-form-field [required]="true">
            <glxy-label>{{
              'SMS_REGULATION.SOUTH_AFRICA.AUTHORIZED_REPRESENTATIVE.IDENTITY_NUMBER' | translate
            }}</glxy-label>
            <input matInput formControlName="contactIdentityNumber" placeholder="0123456789012" />
            <glxy-hint>{{
              'SMS_REGULATION.SOUTH_AFRICA.AUTHORIZED_REPRESENTATIVE.IDENTITY_NUMBER_HINT' | translate
            }}</glxy-hint>
          </glxy-form-field>

          <sms-document-uploader
            [parentFormGroup]="contactFormGroup"
            [options]="[
              {
                label: 'SMS_REGULATION.SOUTH_AFRICA.AUTHORIZED_REPRESENTATIVE.ACCEPTED_DOCUMENTS.GOVERNMENT_ISSUED_ID',
                value: 'government_issued_document',
              },
            ]"
            [fieldTitle]="'SMS_REGULATION.SOUTH_AFRICA.AUTHORIZED_REPRESENTATIVE.ACCEPTED_DOCUMENTS.TITLE'"
            [fieldHint]="'SMS_REGULATION.SOUTH_AFRICA.AUTHORIZED_REPRESENTATIVE.ACCEPTED_DOCUMENTS.HINT'"
          ></sms-document-uploader>

          <glxy-form-field [required]="true">
            <glxy-label>{{
              'SMS_REGULATION.SOUTH_AFRICA.AUTHORIZED_REPRESENTATIVE.NATIONALITY' | translate
            }}</glxy-label>
            <input matInput formControlName="contactNationality" />
          </glxy-form-field>

          <sms-address-fields [parentFormGroup]="contactFormGroup"></sms-address-fields>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div class="regulatory-form-action-container">
    <button (click)="submitRegulatoryForm()" color="primary" mat-flat-button type="submit">
      {{ 'SMS_REGULATION.COMMON.SUBMIT' | translate }}
    </button>
  </div>
</form>
